export const TIMEZONES = {
  PT: 'PT',
  MT: 'MT',
  CT: 'CT',
  ET: 'ET',
  AT: 'AT', // Alaska Time
  HT: 'HT', // Alaska Time
} as const;

const pacificStates = ['CA', 'NV', 'OR', 'WA'];
const mountainStates = ['AZ', 'CO', 'ID', 'MT', 'NM', 'UT', 'WY'];
const centralStates = [
  'AL',
  'AR',
  'IA',
  'IL',
  'KS',
  'KY',
  'LA',
  'MN',
  'MO',
  'MS',
  'ND',
  'NE',
  'OK',
  'SD',
  'TN',
  'TX',
  'WI',
];
const easternStates = [
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'IN',
  'MA',
  'MD',
  'ME',
  'MI',
  'NH',
  'NJ',
  'NY',
  'NC',
  'OH',
  'PA',
  'RI',
  'SC',
  'VA',
  'VT',
  'WV',
];

export const getStateTimezone = (stateCode: string) => {
  if (pacificStates.includes(stateCode)) return TIMEZONES.PT;
  if (mountainStates.includes(stateCode)) return TIMEZONES.MT;
  if (centralStates.includes(stateCode)) return TIMEZONES.CT;
  if (easternStates.includes(stateCode)) return TIMEZONES.ET;
  if (stateCode === 'HI') return TIMEZONES.HT;
  if (stateCode === 'AK') return TIMEZONES.AT;
  return TIMEZONES.ET;
};

export const IANATimezones = {
  PT: 'America/Los_Angeles',
  MT: 'America/Denver',
  CT: 'America/Chicago',
  ET: 'America/New_York',
  AK: 'America/Anchorage',
  HAST: 'Pacific/Honolulu',
  AZ: 'America/Phoenix',
};
